import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageRepositoryService } from '../abstract-repository.service';
import { IQnaheader } from './qnaheader.model';

@Injectable({
  providedIn: 'root',
})
export class QnaheaderApi extends PageRepositoryService<IQnaheader> {
  override baseUri = 'api/qnaheader';

  constructor(protected override http: HttpClient) {
    super(http);
  }

  getUnreadCount(params: any = {}): Observable<number> {
    const httpParams = this.makeObjToHttpParams(params);

    return this.http
      .get<any>(`${this.apiServerUrl}/${this.baseUri}/unreadCount`, {
        params: httpParams,
      })
      .pipe(this.retryUncompleteError());
  }
}
